import React from 'react';

export const LinkButton = ({
  className,
  label,
  children,
  onClick,
  ...otherProps
}) => (
  <div
    style={{ cursor: 'pointer' }}
    className={className}
    {...otherProps}
    onClick={() => {
      if (onClick) {
        onClick();
      }
    }}
  >
    <span
      style={{
        fontFamily: 'Brown',
        fontSize: 14,
        textDecorationLine: 'underline',
        color: '#2E2B2B',
      }}
      className='label mt-3'
    >
      {children}
    </span>
  </div>
);
